import * as React from 'react';
export const IcHands = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 10a1 1 0 00-1 1v3a1 1 0 11-2 0V9.91a2 2 0 01.34-1.11l3.49-5.25a1 1 0 00-1.66-1.1l-3.5 5.24A4 4 0 005 9.91V17a5 5 0 01-.26 1.58l-.25.76A2 2 0 006.39 22h1.83a2 2 0 001.94-1.52l.54-2.16c.2-.795.3-1.61.3-2.43V11a1 1 0 00-1-1zm9.51 9.37l-.25-.76A5 5 0 0119 17V9.91a4 4 0 00-.67-2.22l-3.5-5.24a1 1 0 10-1.66 1.1l3.49 5.25A2 2 0 0117 9.91V14a1 1 0 01-2 0v-3a1 1 0 00-2 0v4.89c0 .82.1 1.635.3 2.43l.54 2.16A2 2 0 0015.78 22h1.83a2 2 0 001.9-2.63z'
      fill='currentColor'
    />
  </svg>
);
